import { useRouter } from "next/router";
import { useTranslation } from "next-i18next";
import InterestStar from "../../components/InterestStar";
import Img from "components/common/List/img";
import Text from "components/common/List/Text";
import { KOREA } from "utils/constant/ITME_INFO";
import { useHighTotalScoreStockList } from "utils/clientAPIs/detailDiagnosis";
import DividerButton from "components/common/divider/button";
import { TYPO } from "styles/Typo";
import { HighScoreStockSkeleton } from "components/skeleton/main";
import { getMainTime } from "utils/api/time";
import StockDetailLink from "components/common/StockDetailLink";
import { TrackedList, TrackedListItem } from "lib/analytics/react/list";
import { TrackedListMoreLink } from "lib/analytics/react/link";
import { ERROR_LOGO_URL, getPublicAssetUrl } from "utils/objectStorage";

function HighScoreList({
  initialList,
}: {
  initialList?: any[] | null;
}) {
  const router = useRouter();
  const { t } = useTranslation("main");
  const [data] = useHighTotalScoreStockList({
    limit: 5,
    fallbackData: initialList ?? undefined,
  });
  const isKoreaTime = getMainTime();

  const isKorean = isKoreaTime;
  const ListTemp = ({ asset, index }: { asset: any; index: number }) => {
    return (
      <li className={` w-full flex items-center  px-6 py-2  gap-3 bg-white`}>
        <div
          // ticker={asset.ITEM_CD_DL}
          className="flex gap-3 grow"
        >
          <div className="justify-center items-center inline-flex">
            <span
              className={` text-center text-blue40  text-[15px] font-semibold leading-none whitespace-nowrap`}
            >
              {`${index + 1}`}
            </span>
          </div>
          <Img
            src={
              getPublicAssetUrl(`logos/${asset.ITEM_CD_DL}.png`) ||
              ERROR_LOGO_URL
            }
            HR_ITEM_NM={""}
          />

          <div
            className={`justify-start grow  overflow-hidden whitespace-pre-wrap flex-col  items-start inline-flex `}
          >
            <Text
              item={
                router.locale === "ko"
                  ? asset.ITEM_KR_NM && asset.ITEM_KR_NM
                  : asset.ITEM_ENG_NM && asset.ITEM_ENG_NM
              }
              price={
                router.locale === "ko"
                  ? asset.ADJ_CLOSE_KRW &&
                    asset.ADJ_CLOSE_KRW.toLocaleString("en-us", {
                      minimumFractionDigits: 0,
                      maximumFractionDigits: 0,
                    }) + (asset.CAT !== "Index" ? "원" : "")
                  : asset.ADJ_CLOSE &&
                    asset.ADJ_CLOSE.toLocaleString("en-us", {
                      minimumFractionDigits: 0,
                      maximumFractionDigits: 0,
                    }) +
                      (asset.CAT !== "Index"
                        ? asset?.LOC === KOREA
                          ? "₩"
                          : "$"
                        : "")
              }
              percent={asset.ADJ_CLOSE_CHG.toLocaleString("en-us", {
                minimumFractionDigits: 0,
                maximumFractionDigits: 2,
              })}
            />
          </div>
        </div>

        <div className="flex items-center shrink-0 justify-end">
          <div>
            {
              <InterestStar
                asset={asset}
                size={30}
                triggerSectionId="explore_attractive_stocks_list"
              />
            }
          </div>
        </div>
      </li>
    );
  };

  if (!data || data?.length === 0)
    return (
      <div className="bg-white">
        <HighScoreStockSkeleton />
      </div>
    );

  return (
    <div className="bg-white">
      {/* <HighTotalScoreStocks /> */}
      <div className="px-6 pt-6">
        <span className={`${TYPO.TYPO4_SB} text-gray80`}>
          {t("highAttractivenessStocks")}
        </span>
      </div>
      <TrackedList
        listId="explore_attractive_stocks_list"
        totalCount={data?.length}
      >
        <div className="py-2 flex flex-col gap-2">
          {data?.slice(0, 5).map((asset: any, index: number) => {
            return (
              <TrackedListItem
                key={index}
                itemData={{
                  kind: "stock",
                  rank: index + 1,
                  ticker: asset.ITEM_CD_DL,
                  market: asset?.LOC === KOREA ? "kr" : "us",
                }}
                href={`/detail/${asset.ITEM_CD_DL}`}
                data-gtm-id={`explore-high-score-list`}
              >
                <ListTemp asset={asset} index={index} />
              </TrackedListItem>
            );
          })}
        </div>
      </TrackedList>

      <TrackedListMoreLink
        href={`/scoreranking?loc=${isKorean ? "korea" : "us"}`}
        listId="explore_attractive_stocks_list"
        data-gtm-id={`explore-high-score-list-more`}
      >
        <DividerButton text={t("viewMore")} />
      </TrackedListMoreLink>
    </div>
  );
}

export default HighScoreList;
